/**
 * @since 2021-08-25
 * @author vivaxy
 */
export default {
  // utils
  DOC: 'Doc',

  // types
  ABSTRACT_TYPE: 'AbstractType',
  Y_ARRAY: 'YArray',
  Y_MAP: 'YMap',
  Y_TEXT: 'YText',
  Y_XML_ELEMENT: 'YXmlElement',
  Y_XML_FRAGMENT: 'YXmlFragment',
  Y_XML_TEXT: 'YXmlText',

  // structs
  ABSTRACT_STRUCT: 'AbstractStruct',
  GC: 'GC',
  ITEM: 'Item',
  SKIP: 'Skip',

  // contents
  CONTENT_ANY: 'ContentAny',
  CONTENT_BINARY: 'ContentBinary',
  CONTENT_DELETED: 'ContentDeleted',
  CONTENT_DOC: 'ContentDoc',
  CONTENT_EMBED: 'ContentEmbed',
  CONTENT_FORMAT: 'ContentFormat',
  CONTENT_JSON: 'ContentJSON',
  CONTENT_STRING: 'ContentString',
  CONTENT_TYPE: 'ContentType',
};
